import { render, staticRenderFns } from "./placard_wallet_conversion.vue?vue&type=template&id=bba7b2da&scoped=true"
import script from "./placard_wallet_conversion.vue?vue&type=script&lang=js"
export * from "./placard_wallet_conversion.vue?vue&type=script&lang=js"
import style0 from "./placard_wallet_conversion.vue?vue&type=style&index=0&id=bba7b2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba7b2da",
  null
  
)

export default component.exports